module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sc-CB"
  }, [_c('button', {
    staticClass: "sc-btn",
    attrs: {
      "title": "拖拽调整位置，点击展开或收起",
      "aria-label": "拖拽调整位置，点击展开或收起"
    },
    on: {
      "click": _vm.boxRotate
    }
  }, [_c('span', {
    staticClass: "sc-block"
  }, [_c('span', {
    staticClass: "sc-block-span1",
    class: _vm.rotateFlag ? 'sc-block-span3' : ''
  }), _vm._v(" "), _c('span', {
    staticClass: "sc-block-span2"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sc-menu1"
    }
  }, [(_vm.rotateFlag) ? _c('div', {
    staticClass: "sc-menu1",
    on: {
      "click": function($event) {
        return _vm.onCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-chat-dot-round"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu2-info"
  }, [_c('div', {
    staticClass: "menu2-left"
  }, [_c('i', {
    staticClass: "el-icon-chat-dot-round",
    staticStyle: {
      "margin": "60% 0 0 30%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu2-right"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', [_vm._v("联系客服")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sc-menu2"
    }
  }, [(_vm.rotateFlag) ? _c('div', {
    staticClass: "sc-menu2"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu2-info"
  }, [_c('div', {
    staticClass: "menu2-left"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline",
    staticStyle: {
      "margin": "60% 0 0 30%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu2-right"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', [_vm._v("客服电话")]), _vm._v(" "), _c('li', [_vm._v("400 088 3316")])])])])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f732be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/customerSer.vue
// module id = 607
// module chunks = 0